export default "__VITE_ASSET__79c825f4__"